import { ArticleTranslation } from 'locales/de/pages/articles';

const en: ArticleTranslation = {
  title: 'Articles',
  headline: 'Headline',
  failedLoading: 'Could not load articles',
  type: {
    general: 'General',
    study: 'Studies',
    event: 'Event',
    legal: 'Legal',
    holiday: 'Holiday'
  },
  showMore: 'Show more',
  showLess: 'Show less',
  noEventsToday: 'There are no events for today',
  noArticles: 'There are no articles at this time',
  viewAll: 'View all',
  pastArticles: 'Article archive',
  myArticles: 'My articles',
  allDay: 'All day',
  appointmentFormat:
    '{{startTime}}{{seperator1}}{{endTime}} | {{startDate}}{{seperator2}}{{endDate}}',
  steps: {
    userGroup: 'Audience',
    category: 'Category',
    mainContent: 'Main content',
    lifetime: 'Lifetime',
    review: 'Review & Publish'
  },
  alerts: {
    saveSuccessful: 'The article was successfully saved.',
    saveFailed: 'The article could not be saved.',
    errorLoading: 'Article creation could not be loaded.'
  },
  tooltips: {
    articleArchive: 'Here you will find all posts whose visibility has already expired.'
  },
  create: {
    title: 'New Article',
    userGroup: {
      author: 'Author role',
      recipients: 'Recipients',
      department: 'Department',
      toDivision: 'Own Division:',
      toTh: 'TH Wide:',
      semester: 'Semester',
      noDepartments: "You don't belong to any department.",
      noAuthorSelected: 'Select an author role in order to get possible recipients',
      noRecipients: 'This author role has no recipients',
      noPossibleAuthor: 'You have no possible author role, which is allowed to create articles.',
      changingPostAs:
        'You do not have the initial author role! You might change the recipients group.'
    },
    general: {
      postAs: 'Post As',
      recipients: 'Recipients',
      selectCategory: 'Choose a category for your article',
      general: 'General',
      generalDescription: "Create a general announcement that doesn't fit in any other category.",
      study: 'Studies',
      studyDescription: 'Create an announcement for study matters.',
      event: 'Event',
      eventDescription: 'Create an event announcement. You can also mark it in the calendar.',
      legal: 'Legal',
      legalDescription: 'Create a announcement of legal requirements.',
      holiday: 'Holiday',
      holidayDescription: 'Create public holidays and free days.'
    },
    mainContent: {
      shortDescription: 'Short Description',
      articleText: 'Article Text',
      attachements: 'Attachement',
      attachementUploadPlaceholder: 'Attachement upload (pdf, doc(x), zip, jpeg)'
    },
    lifetime: {
      venue: 'Venue',
      eventDate: 'Event Date',
      eventDateEnd: 'Event ends on',
      eventDateDescription:
        "Provide the event's date. This day will be marked in the calendar and provide a link to this announcement. The event can either last the whole day or for a specified duration.",
      holidayDateDescription:
        "Provide the event's date. This day will be marked in the calendar and provide a link to this announcement. Holiday can only last the whole day.",
      wholeDay: 'Whole Day',
      eventDuration: 'Event Duration',
      lifetime: 'Article Lifetime',
      lifetimeDescription:
        "Specify the lifetime of this article. During this time the article will be displayed to appropriate audiences. After that it will be moved to the archive. If you don't provide an end date, the system will assume a default duration of 14 days.",
      startDate: 'Visible from',
      endDate: 'Visible until',
      lifetimeDescriptionEvent:
        'The article will be displayed until the day of the event. After that it will be moved to the archive.',
      withAppointment: 'Calendar appointment',
      withAppointmentDescription:
        'Do you want to add an appointment to the calendar for this article?'
    },
    preview: {
      mailNotSend: 'Should no e-mail notification be triggered for this post?',
      pushNotificationDescription:
        'Should this post also be sent as a push notification to mobile devices?',
      mailNotSendAlert:
        'No email notification is triggered for this post. This is useful, for example, for reminders that are only important today or maintenance work that only takes place today and that should not appear in the collective email of the post overview the next day. This setting can only be made during initial creation.',
      pushNotificationAlert:
        'Please note that the notification is sent as a summarized collective notification and could be deselected by the user`s individual settings. If this is an urgent notification, please use the emergency notification provided for this purpose if you are authorized to do so.'
    },
    tooltips: {
      organizingRoles:
        'Users with one of the selected roles can edit the article and contact the recipients'
    }
  },
  edit: {
    title: 'Edit article'
  },
  inspect: {
    title: 'Inspection',
    reachedUsers: 'Reached users'
  },
  filter: {
    keyword: 'Keyword (Title / Short description)',
    articletype: 'Article type',
    startDate: 'Visible from',
    endDate: 'Visible until',
    division: 'Division'
  }
};

export default en;
